import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateCushionChargePolicy } from 'api/company/updateCushionChargePolicy'
import { cushionChargePoliciesKey } from './keys'

type UseUpdateCushionChargePolicyMutationRequest = Omit<
  Parameters<typeof updateCushionChargePolicy>[0],
  'companyId'
>

export function useUpdateCushionChargePolicyMutation(companyId: number) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: UseUpdateCushionChargePolicyMutationRequest) =>
      updateCushionChargePolicy({ companyId, ...request }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: cushionChargePoliciesKey(companyId),
      })
    },
  })
}
